import React from 'react'
import { handlePageException } from 'utils/error'
import ErrorPage from 'pages/Minimal/ErrorPage'

export default class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
    handlePageException(error, info)
  }

  render() {
    const { hasError } = this.state
    const { fallBack, children } = this.props

    if (hasError) {
      // You can render any custom fallback UI
      return fallBack || <ErrorPage {...this.props} />
    }
    return children
  }
}
